import { observer } from "mobx-react";
import ReactDOM from "react-dom";
import { ITooltipViewModel } from "../../../../services/tooltip/tooltip-base/tooltip-view-model.interface";
import { OrbitComponent } from "../../../base-components/orbit-component/orbit-component";
import { ThemeProvider } from "styled-components";
import { ToolTipLightWeightContainerBox } from "../../boxes/tooltip-container/tooltip-lightweight-container.box";
import { TooltipContainerBox } from "../../boxes/tooltip-container/tooltip-container.box";
import { CyClass } from "../../../../../common/cy-classes";
import { TooltipGlowBox } from "../../boxes/tooltip-glow/tooltip-glow.box";
import { TooltipCloseButtonBox } from "../../boxes/tooltip-close-button.box";
import { TooltipContentBox } from "../../boxes/tooltip-content.box";
import { TooltipArrowBox } from "../../boxes/tooltip-arrow/tooltip-arrow.box";

interface GenericToolTipComponentProps {
    toolTip: ITooltipViewModel;
}

export const GenericToolTipComponent = observer(class GenericToolTipComponent extends OrbitComponent<GenericToolTipComponentProps> {

    private _captureElementRef = (element: HTMLDivElement) => {
        if (element) {
            this.props.toolTip.onToolTipRendered(element);
        }
    }

    render() {
        const currentTooltip = this.props.toolTip;
        if (!currentTooltip.shouldDisplay()) {
            return null;
        }

        const content = currentTooltip?.render();

        // Some tooltips (the new explorer onboarding one, for example) have their own specific style and do not use the general one with glow/arrow etc
        //In this case, the content component is responsible with the styling.
        if (currentTooltip.hasOwnStyle) {
            return ReactDOM.createPortal(
                <ThemeProvider theme={this.services.theme.popupsTheme}>
                    <ToolTipLightWeightContainerBox ref={this._captureElementRef} zIndex={currentTooltip?.zIndex || 0}>
                        {content}
                    </ToolTipLightWeightContainerBox>
                </ThemeProvider>
                , this.services.dom.body);
        }

        const hasGlow = Boolean(currentTooltip?.hasGlow);

        return ReactDOM.createPortal(
            <ThemeProvider theme={this.services.theme.popupsTheme}>
                <TooltipContainerBox
                    className={CyClass('cy-tooltip-container')}
                    ref={this._captureElementRef}
                    zIndex={currentTooltip?.zIndex || 0}
                    active={Boolean(currentTooltip)}
                    animated={Boolean(currentTooltip?.animated)}
                    hasGlow={hasGlow}
                    {...currentTooltip?.styling}>

                    {hasGlow && <TooltipGlowBox />}

                    {currentTooltip?.shouldShowCloseButton && <TooltipCloseButtonBox onClick={() => currentTooltip.closeTooltip()} invertColors={currentTooltip.invertCloseButtonColors} />}

                    <TooltipContentBox>
                        {content}
                    </TooltipContentBox>

                    <TooltipArrowBox
                        id="tool-tip-container-arrow"
                        data-popper-arrow=""
                        {...currentTooltip?.styling}
                    />

                    {hasGlow && <TooltipGlowBox bottom />}

                </TooltipContainerBox>
            </ThemeProvider>
            , this.services.dom.body);
    }
});